export default __webpack_public_path__ + "static/2 Singing Mermaid-Little Angel Theatre-d0a972ffd46ea1f468ebbe5eb5fdebcd.jpg";